import { type ChangeEvent, PureComponent } from 'react';
import { union, without } from 'lodash-es';
import { Translation, Trans } from 'react-i18next';

import { FontLicenseType } from 'client/graphql/types/operations';

import * as Core from 'components/core';

interface Props {
  licenseTypes: FontLicenseType[];
  disabled: boolean;
  onChange(allChecked: boolean): void;
}

interface State {
  checkedLicenseTypes: FontLicenseType[];
}

export class LicenseCheckboxes extends PureComponent<Props, State> {
  static displayName = 'Checkout.LicenseCheckboxes';
  static defaultProps = { disabled: false };

  state: State = {
    checkedLicenseTypes: [],
  };

  handleChange = (
    licenseType: FontLicenseType,
    event: ChangeEvent<HTMLInputElement>,
  ) => {
    const { checked } = event.currentTarget;

    this.setState((state) => {
      if (checked) {
        return {
          ...state,
          checkedLicenseTypes: union(state.checkedLicenseTypes, [licenseType]),
        };
      } else {
        return {
          ...state,
          checkedLicenseTypes: without(state.checkedLicenseTypes, licenseType),
        };
      }
    });
  };

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.checkedLicenseTypes !== this.state.checkedLicenseTypes) {
      this.props.onChange(
        this.state.checkedLicenseTypes.length ===
          this.props.licenseTypes.length,
      );
    }
  }

  render() {
    const { disabled } = this.props;
    const { checkedLicenseTypes } = this.state;

    return (
      <Translation ns={['translation', 'checkout']}>
        {(t) =>
          this.props.licenseTypes.map((licenseType) => (
            <Core.Checkbox
              key={licenseType}
              disabled={disabled}
              checked={checkedLicenseTypes.includes(licenseType)}
              testID={`${licenseType.toLowerCase()}-license-checkbox`}
              onChange={this.handleChange.bind(null, licenseType)}
              required
            >
              <Trans
                ns="checkout"
                i18nKey="payment.agreeToTerms"
                values={{
                  licenseType: t(
                    `licenseType.${licenseType.toLowerCase()}.fullName`,
                  ),
                }}
              >
                <Core.Link
                  to={`/licensing#${licenseType.toLowerCase()}`}
                  target="_blank"
                >
                  Font
                </Core.Link>
              </Trans>
            </Core.Checkbox>
          ))
        }
      </Translation>
    );
  }
}

export default LicenseCheckboxes;
